import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CardState, showHide} from '../../../animations';

interface Items {
  name: string;
  icon: string;
  disabled: boolean
}

@Component({
  selector: 'as-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
  animations: [showHide]
})
export class ContextMenuComponent implements OnInit {

  @Input() menuItems: Array<Items>;
  @Input() flyoutPosition: string;
  @Input() disabled:boolean = false;
  @Input() customMarginTop;
  @Input() name: string;

  @Output() contextItemAction = new EventEmitter();

  state = CardState.Closed;
  backgroundShow: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }

  expand() {

    this.state = (this.state == CardState.Open) ? CardState.Closed : CardState.Open;
    this.backgroundShow = !this.backgroundShow;
  }

  actionContextItem(name: string) {
    this.contextItemAction.emit(name);
    this.expand();
  }
}
